export const ANIMATION_STEPS = {
  ANIMATE_BRACKETS: 'animate-brackets',
  MOVE_TEXT: 'move-text',
  ANIMATE_CONTENT: 'animate-content'
};
